import React, { PropsWithChildren } from 'react';

import EmptyList from '../../Components/EmptyList/EmptyList';
import { InnerListStyled } from '../../Components/InnerList.styles';
import { IListItem } from '../../Utils/IListItem';
import { IListProps } from '../../Utils/IListProps';

type IInnerListProps<T extends IListItem> = Pick<
  IListProps<T>,
  | 'context'
  | 'customFilter'
  | 'customSort'
  | 'filters'
  | 'itemHeight'
  | 'items'
  | 'listHeight'
  | 'renderItem'
  | 'sorting'
> & { selected: number };

const InnerList = <T extends IListItem>(props: PropsWithChildren<IInnerListProps<T>>) => {
  const {
    customSort,
    sorting,
    itemHeight,
    renderItem: Item,
    context,
    listHeight,
    items,
    customFilter,
    filters,
    selected
  } = props;

  const sortItems = (selectedItem: number) => (a: T, b: T): number =>
    customSort ? customSort(a, b) : sorting ? sorting[selectedItem].callback(a, b) : 0;

  const renderItems = items
    .filter(item => {
      const newCustomFilter = customFilter ? customFilter(item) : true;
      const newLocalFilter = filters ? filters[selected].callback(item) : true;

      return newCustomFilter && newLocalFilter;
    })
    .sort(sortItems(selected));

  return (
    <InnerListStyled className="list-body" listHeight={listHeight}>
      {renderItems.length ? (
        renderItems.map(item => (
          <div
            key={`list-item-${item.id}`}
            style={
              itemHeight && itemHeight > 0 ? { height: itemHeight } : { minHeight: itemHeight }
            }
          >
            <Item item={item} context={context} />
          </div>
        ))
      ) : (
        <EmptyList />
      )}
    </InnerListStyled>
  );
};

export default InnerList;
